import { styled } from 'linaria/react';

export const FormStyled = styled.form`
  width: 100%;
`;

export const StyledHeading = styled.div`
  position: relative;
  margin-bottom: var(--space-200);

  @media (--only-mobile) {
    margin-bottom: var(--space-100);
  }
`;

export const DimensionsFormContainer = styled.div`
  display: flex;
  width: 100%;
  height: calc(100% - var(--space-200));
  margin-top: var(--space-200);

  @media (--only-mobile) {
    display: block;
  }
`;

export const TextContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--space-125);
`;

export const MaterialsContainer = styled.div`
  display: flex;
  gap: var(--space-400);
  margin-bottom: var(--space-125);
`;

export const MaterialInfoContainer = styled.div`
  display: flex;
  gap: var(--space-50);
`;

export const AreaFormContainerRow = styled.div<{ hasDoorsWindows?: boolean }>`
  width: 100%;
  margin-bottom: ${props => (props.hasDoorsWindows ? '12px' : '0')};

  @media (--only-mobile) {
    margin-bottom: ${props => (props.hasDoorsWindows ? '8px' : '0')};
  }
`;

export const AreaFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  @media (--only-mobile) {
    padding-top: 0;
  }
  @media (--only-tablet) {
    width: 85%;
    max-width: 552px;
  }
  @media (min-width: 768px) and (max-width: 1023px) {
    width: 80%;
  }
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-250);
  height: 100%;
`;

export const FooterWrapper = styled.div`
  position: relative;
  margin-top: var(--space-250);
`;

export const MeasurmentBannerWrapper = styled.div`
  position: relative;
  margin-right: 0px;
  margin-left: auto;

  @media (--only-tablet) {
    margin: var(--space-400) 0px 0px;
    margin-bottom: var(--space-500);
  }
  @media (--only-mobile) {
    margin: var(--space-400) 0px var(--space-1000);
  }
`;

const FormColumn = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

export const FormColumnRight = styled(FormColumn)`
  flex-basis: 306px;
  @media (--to-tablet) {
    flex-basis: auto;
  }
`;
export const FormColumnLeft = styled(FormColumn)`
  flex-basis: 525px;
  @media (--to-tablet) {
    flex-basis: auto;
  }
`;

export const FormRow = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  @media (--to-tablet) {
    flex-direction: column;
  }
`;

export const FormRowFooter = styled(FormRow)`
  @media (--to-tablet) {
    bottom: var(--space-25);
    margin-top: auto;
  }
  @media (--only-mobile) {
    position: fixed;
    bottom: var(--space-200);
    z-index: 999;
    width: calc(100% - var(--space-400));
  }
`;
